export const RULE_TYPES = {
  PRE_UPDATE: "pre-update",
  POST_UPDATE: "post-update",
};

export const RULE_SUB_TYPES = {
  NOTIFICATION: "notification",
  VALIDATION: "validation",
  PEAK_TIME: "peak-time",
};

export const PRE_UPDATE_SUB_TYPE_LABELS = ["Schema Validation", "Peak Time"];
export const POST_UPDATE_SUB_TYPE_LABELS = ["Notification"];
export const PEAK_TIME_PAYLOAD_PARAM = ["StartTime", "EndTime", "Repeat"];
export const REPEAT_OPTIONS = [
  { key: 0, label: "Does not repeat" },
  { key: 1, label: "Daily" },
  { key: 2, label: "Weekly" },
  { key: 3, label: "Monthly" },
  { key: 4, label: "Yearly" },
];

export const BYTES = {
  KB: 1024,
  MB: 1024 * 1024,
};
